import React from "react";
import { Card, CardBody } from "reactstrap";
import BarGraph from "../components/bargraph";

const SkeletonBox = ({ width, height, style }) => (
    <div
        className="skeleton-box"
        style={{ width: width || '100%', height: height || '20px', ...style }}
    />
);

const BarChartCard = ({
    title,
    value,
    percentageChange,
    formattedPercentageChange,
    xAxis,
    yAxis,
    dataName,
    isLoading = false,
}) => {
    return (
        <CardBody className="p-3">
            <h5 className="fs-3 mb-4">{title}</h5>
            {isLoading ? (
                <>
                    <div className="d-flex flex-row align-items-center mb-3" style={{ gap: '8px' }}>
                        <SkeletonBox width="80px" height="26px" />
                        <SkeletonBox width="50px" height="18px" />
                    </div>
                    <SkeletonBox width="100%" height="220px" style={{ borderRadius: '6px' }} />
                </>
            ) : (
                <>
                    <p className="mt-2 d-flex flex-row">
                        <span className="bold fs-7">
                            <b>{value}</b>
                        </span>
                        <span
                            className="fs-1 pl-2 mt-3"
                            style={{
                                color: percentageChange > 0 ? "green" : percentageChange < 0 ? "red" : "black"
                            }}
                        >
                            {formattedPercentageChange}
                        </span>
                    </p>
                    <BarGraph
                        title=""
                        dataName={dataName}
                        xAxis={xAxis}
                        yAxis={yAxis}
                        showLoading={isLoading}
                    />
                </>
            )}
        </CardBody>
    );
};

export default BarChartCard;
